import Cookies from 'js-cookie';

document.addEventListener("DOMContentLoaded", () => {
    const trackParams = {
        'utm_source': 'utm_source',
        'utm_medium': 'utm_medium',
        'utm_campaign': 'utm_campaign',
        'utm_term': 'utm_term',
        'mc_cid': 'mc_cid',
        'mc_eid': 'mc_eid',
    };

    const urlParams = new URLSearchParams(window.location.search);
    let hasParams = false;

    Object.keys(trackParams).forEach(param => {
        const paramValue = urlParams.get(trackParams[param]);

        if (paramValue && paramValue.toLowerCase() !== 'pantheon_stripped') {
            Cookies.set(param, paramValue, { expires: 10 });
            hasParams = true;
        } else {
            const cookieValue = Cookies.get(param);
            if (cookieValue) {
                hasParams = true;
            }
        }
    });

    function getSubdomain() {
        const hostname = window.location.hostname;
        const parts = hostname.split('.');

        if (parts.length > 2) {
            return parts[0];
        } else {
            return null;
        }
    }

    const subdomain = getSubdomain();
    const links = document.querySelectorAll('a[href*="https://decisely.com"]');

    links.forEach(link => {

        let href = link.getAttribute('href');
        const url = new URL(href);
        url.searchParams.set('referring_site', subdomain);

        if (hasParams) {
            Object.keys(trackParams).forEach(param => {
                const cookieValue = Cookies.get(param);
                if (cookieValue) {
                    url.searchParams.set(trackParams[param], cookieValue);
                } else if (urlParams.has(trackParams[param]) && urlParams.get(trackParams[param]).toLowerCase() !== 'pantheon_stripped') {
                    url.searchParams.set(trackParams[param], urlParams.get(trackParams[param]));
                }
            });
        }

        link.setAttribute('href', url.toString());
    });
});


document.addEventListener('DOMContentLoaded', () => {
    // Observer to ensure the form is loaded before populating fields
    const observer = new MutationObserver((mutations, observer) => {
        const formLoaded = document.querySelector('.utm_source input');
        if (formLoaded) {
            populateUtmFields();
            observer.disconnect();
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    // Define the function to populate UTM fields
    function populateUtmFields() {
        const params = new URLSearchParams(window.location.search);
        const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'mc_eid', 'mc_cid'];

        utmParams.forEach(param => {
            const paramValue = params.get(param) ? params.get(param).toLowerCase() : null;
            const cookieValue = Cookies.get(param);
            const field = document.querySelector(`.${param} input`);

            if (field) {
                if (paramValue && paramValue !== 'pantheon_stripped') {
                    field.removeAttribute('value');
                    field.value = paramValue; 
                } else if (!paramValue && cookieValue) {
                    field.removeAttribute('value');
                    field.value = cookieValue;
                } else if (paramValue === 'pantheon_stripped') {
                    field.removeAttribute('value');
                    field.value = cookieValue ? cookieValue : '';
                }
            }
        });
    }
});